import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.css']
})
export class StepsComponent implements OnInit {
  @Input() numberActive:number=0;
  constructor() { }

  ngOnInit(): void {
  }

}
